import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdminHeaderComponent } from './admin-header/admin-header.component';
import { AdminSidebarComponent } from './admin-sidebar/admin-sidebar.component';
import { AdminEnvLabelComponent } from './admin-header/admin-env-label/admin-env-label.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AdminHeaderComponent,
    AdminSidebarComponent,
    AdminEnvLabelComponent
  ],
  exports: [AdminHeaderComponent, AdminSidebarComponent]
})
export class LayoutModule { }
